import { read } from '@/utils/request'
import type { EntitySpendAPI } from '@/services/policyInsight/entitySpend/typings'

const getList = (params: EntitySpendAPI.SearchParams, signal?: any) => read<EntitySpendAPI.List>(
  'policy_insight/entity_spend', params, undefined, undefined, { signal }
)

export {
  getList,
}
